exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 767px) and (max-width: 1200px) {\n#parts-details-modal button.slick-prev.slick-arrow,\n#parts-details-modal button.slick-next.slick-arrow {\n    height: 30px;\n}\n#parts-details-modal .slick-next {\n    right: -23px !important;\n}\n#parts-details-modal .col-xs-12.col-md-6.m-b {\n    padding-right: 21px;\n}\n}\n#parts-details-modal .product-name small {\n  color: white;\n}", ""]);

// exports
